import * as yup from "yup";
import { channelListIdValidation } from "../data/Data";

const SUPPORTED_FORMATS = ["image/jpg", "image/jpeg", "image/gif", "image/png"];

export const validationSchema = yup.object({
  lastName: yup
    .string()
    .max(50)
    .required("Please input last name 請輸入姓氏"),
  firstName: yup
    .string()
    .max(50)
    .required("Please input first name 請輸入名字"),
  mobile: yup
    .string()
    .when("select", (select, schema) => {
      if (select[0]?.value === "852") {
        return schema
          .required("*Please input valid mobile number 請輸入有效聯絡電話號碼")
          .matches(
            /^[4-9][0-9]{7}$/,
            "Please input valid mobile number 請輸入有效聯絡電話號碼"
          )
          .length(
            8,
            "*Please input valid mobile number 請輸入有效流動電話號碼"
          );
      } else if (select[0]?.value === "853") {
        return schema
          .matches(
            /^[6][0-9]{7}$/,
            "Please input valid mobile number 請輸入有效流動電話號碼"
          )
          .length(8, "*Please input valid mobile number 請輸入有效流動電話號碼")
          .required("*Please input valid mobile number 請輸入有效流動電話號碼");
      } else if (select[0]?.value === "86") {
        return schema
          .matches(
            /^[1][0-9]{10}$/,
            "Please input valid mobile number 請輸入有效流動電話號碼"
          )
          .length(11, "Please input valid mobile number 請輸入有效流動電話號碼")
          .required("Please input valid mobile number 請輸入有效流動電話號碼");
      }
      return schema;
    })
    .required("Please input valid mobile number 請輸入有效流動電話號碼"),
  email: yup
    .string()
    .email("Please input valid email address 請輸入有效電郵地址")
    .max(100)
    .required("Please input valid email address 請輸入有效電郵地址"),
  purchaseDate: yup
    .string()
    .nullable()
    .required("Please select purchase date 請選擇購買日期"),
  // totalPurchaseAmount: yup
  //   .number()
  //   .typeError(
  //     "Total purchase amount must be equal to or greater than HK$8,000 總購買金額必須等於或大於港幣八千元"
  //   )
  //   .min(
  //     8000,
  //     "Total purchase amount must be equal to or greater than HK$8,000 總購買金額必須等於或大於港幣八千元"
  //   )
  //   .required(
  //     "Total purchase amount must be equal to or greater than HK$8,000 總購買金額必須等於或大於港幣八千元"
  //   ),
  invoiceNumber: yup
    .string()
    .min(15, "Please input valid IMEI# 請輸入有效IMEI#")
    .max(15, "Please input valid IMEI# 請輸入有效IMEI#")
    .required("Please input valid IMEI# 請輸入有效IMEI#"),
  // purchaseChannel: yup
  //   .number()
  //   .required("Please select purchase channel 請選擇購買渠道")
  //   .oneOf(channelListIdValidation),
  txtChannel: yup
    .string()
    .max(50)
    .required("Please input purchase channel 請輸入購買渠道"),
  fileInvoice1: yup
    .mixed()
    .test("required", "Please upload receipt image 請上載購買單據", (file) => {
      if (file.length >= 1) return true;
      return false;
    })
    .test("fileType", "Unsupported File Format 檔案格式錯誤", (value) => {
      return SUPPORTED_FORMATS.includes(value[0]?.type);
    })
    .test("fileSize", "The file is too large 檔案容量過大", (file) => {
      console.log(file[0]?.size);
      return file && file[0]?.size <= 6000000;
    }),
  fileInvoice2: yup
    .mixed()
    .notRequired()
    .test("fileType", "Unsupported File Format 檔案格式錯誤", (value) => {
      if (value && value.length > 0) {
        return SUPPORTED_FORMATS.includes(value[0]?.type);
      }
      return true; // Return true if no file is provided
    })
    .test("fileSize", "The file is too large 檔案容量過大", (file) => {
      if (file && file.length > 0) {
        return file[0]?.size <= 6000000;
      }
      return true; // Return true if no file is provided
    }),
  gameAnswer: yup
    .string()
    .max(4000)
    .required("Please enter your answer here 請輸入答案"),
  privacyPolicy: yup
    .boolean()
    .oneOf(
      [true],
      "Please read and agree to the Terms and Conditions 請閱覽及同意條款及細則"
    ),
  privacyPolicy2: yup
    .boolean()
    .oneOf(
      [true],
      "Please read and agree to the Personal Information Collection Statement 請閱覽及同意個人資料收集聲明"
    ),
  // newsLetter: yup
  //   .boolean()
  //   .oneOf(
  //     [true],
  //     "* Please read and agree to the Personal Information Collection Statement 請閱覽及同意個人資料收集聲明"
  //   ),
});
